module.exports = __webpack_public_path__ + "static/img/location-banner-img.09a11310.jpg";